<template>
<v-container fluid>
    <v-card class="ma-2" outlined rounded>
        <v-card-title>
            <v-btn icon @click="$router.go(-1)">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            {{ groupInfo.name }}
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
        </v-card-title>
        <!-- <v-data-table :headers="headers" :items="userList" :search="search" sort-by="weight" item-class="cellClass" :footer-props="{ 'items-per-page-options': [10, 20, 30, 50, 100, -1] }" :options="options" :loading="loading">
            <template v-slot:[`item.avatar`]="{ item }">
                <v-avatar v-if="item.pictureUrl" size="32" class="mr-2">
                    <img :src="item.pictureUrl" />
                </v-avatar>
                <v-avatar v-else color="info" size="32" class="mr-2">
                    <v-icon dark> mdi-account-circle </v-icon>
                </v-avatar>
                {{ item.name }}
            </template>
        </v-data-table> -->
        <ReportChallengeDataPersonComponent :group_id="group_id" :id="id" :userList="userList"/>
    </v-card>
</v-container>
</template>

<script>
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import {
    mapGetters
} from "vuex";
import formatData from "../utils/formatData"
import getGroupInfoById from "../data/getGroupInfoById";
import bqGetReportChallengeDataByGroup from "../data/bqGetReportChallengeDataByGroup";
import ReportChallengeDataPersonComponent from "../components/ReportChallengeDataPersonComponent.vue";
export default {
    name: 'ChallengeUserList',
    metaInfo: {
        title: 'Challenge User List'
    },
    components: {
        ReportChallengeDataPersonComponent
    },
    data() {
        return {
            search: "",
            options: {
                itemsPerPage: 20,
            },
            groupInfo: [],
            userList: [],
            loading: false,
            datatest: []
        };
    },

    created() {
        var vm = this;
        vm.$store.state.appTitle = "Thaisook Web Admin | Challenge";
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                vm.$store.dispatch("autoSignIn", user);
                this.loading = true;
                setTimeout(() => {
                    vm.initialize();
                }, "1000");
            } else {
                console.log("no user");
            }
        });

        this.group_id = this.$route.params.group_id;
        this.id = this.$route.params.id;
    },
    computed: {
        ...mapGetters([
            "isAuthenticated",
            "isSuperAdmin",
            "isChallengeAdmin"
        ]),
    },
    methods: {
        initialize() {
            if (this.isSuperAdmin || this.isChallengeAdmin) {
                (async () => {
                    if( this.group_id != 'user' ) {
                        this.loading = true;
                        this.groupInfo = await getGroupInfoById(this.group_id);
                        this.loading = false;
                    }
                    else{
                        this.groupInfo = {
                            name: 'All Users'
                        }
                    }
                })();
                (async () => {
                    if (localStorage.getItem('startDate') && localStorage.getItem('endDate')) {
                        this.startDate = localStorage.getItem('startDate');

                        this.endDate= localStorage.getItem('endDate');

                        this.loading = true;
                        this.userList = await bqGetReportChallengeDataByGroup(this.id, this.group_id, this.startDate, this.endDate);
                        this.loading = false;
                    }
                })();
            } else {
                this.$router.push(`/dashboard`);
            }
        },
        _formatData(type, value) {
            return formatData(type, value);
        },
        goToGroupList() {
            this.$router.push(`/challenge/${this.id}`);
        },
        // goToUserDetail(item) {
        //     this.$router.push(`/challenge/${this.id}/${this.group_id}/${item.id}`);
        // },
    },
};
</script>
